import React from "react";
import { Card, CardContent, Box } from "@mui/material";
import { AlertCircle } from "react-feather";
import { SectionTitle } from "./UiBits";

import {
  RadarChart,
  PolarGrid,
  PolarAngleAxis,
  PolarRadiusAxis,
  Radar,
  ResponsiveContainer,
} from "recharts";

export default function FattoriRischioRadar({ theme, cardSx, contentSx, radarData }) {
  return (
    <Card sx={cardSx}>
      <CardContent sx={contentSx}>
        <SectionTitle icon={<AlertCircle size={18} />} title="Fattori di Rischio" />

        <Box sx={{ height: 300, display: "flex", alignItems: "center" }}>
          <ResponsiveContainer width="100%" height="100%">
            <RadarChart data={radarData}>
              <PolarGrid stroke={theme.palette.divider} />
              <PolarAngleAxis
                dataKey="subject"
                tick={{ fill: theme.palette.text.secondary, fontSize: 12 }}
              />
              <PolarRadiusAxis angle={90} domain={[0, 10]} tick={false} />
              <Radar
                name="Fattori"
                dataKey="value"
                stroke={theme.palette.primary.main}
                fill={theme.palette.primary.main}
                fillOpacity={0.55}
              />
            </RadarChart>
          </ResponsiveContainer>
        </Box>
      </CardContent>
    </Card>
  );
}